/*jslint node: true*/

"use strict";

require("../../vendor/fileUpload/jquery.ui.widget.js");
require("../../vendor/fileUpload/jquery.iframe-transport.js");
require("../../vendor/fileUpload/jquery.fileupload.js");

require("./fileStoreUpload");

var fileStoreDownload = require("./fileStoreDownload");
var fileViewModel = require("./fileViewModel");
var uploadViewModelExtras = require("./uploadViewModelExtras");

module.exports = {
    fileStoreDownload: fileStoreDownload,
    fileViewModel: fileViewModel,
    uploadViewModelExtras: uploadViewModelExtras
};



//////////////////
// WEBPACK FOOTER
// ./app/filestore/index.js
// module id = 502
// module chunks = 49